import React, { useMemo, useState, createContext, useContext } from 'react';
interface ReaderState {
  isReading: boolean;
  exitReader: () => void;
  setReader: (next: {
    isReading: boolean;
    onExit?: () => void;
  }) => void;
}
const ReaderStateContext = createContext<ReaderState | null>(null);
export function ReaderStateProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isReading, setIsReading] = useState(false);
  const [onExit, setOnExit] = useState<(() => void) | null>(null);
  const value = useMemo<ReaderState>(() => ({
    isReading,
    exitReader: () => {
      if (onExit) onExit();
    },
    setReader: ({
      isReading,
      onExit
    }) => {
      setIsReading(isReading);
      // store the handler as a function inside a function so React
      // doesn't try to call it as a state updater.
      setOnExit(() => onExit ? onExit : null);
    }
  }), [isReading, onExit]);
  return <ReaderStateContext.Provider value={value} data-id="element-1147">
      {children}
    </ReaderStateContext.Provider>;
}
export function useReaderState() {
  const ctx = useContext(ReaderStateContext);
  if (!ctx) {
    // Safe fallback: if used outside provider, return no-op state.
    return {
      isReading: false,
      exitReader: () => {},
      setReader: () => {}
    } as ReaderState;
  }
  return ctx;
}